import axios from 'axios.js'

export const GET_COMPANY = 'GET_COMPANY'
export const GET_LOCATION = 'GET_LOCATION'
export const GET_FOREMAN = 'GET_FOREMAN'
export const GET_WORKJOB = 'GET_WORKJOB'
export const GET_SHIFT = 'GET_SHIFT'



export const getCompany = (filter) => (dispatch) => {
    const search_url = "/api/common/company"
    axios.post(search_url,filter).then((res) => {
        if(res.data.result_status === 200){
            dispatch({
                type: GET_COMPANY,
                payload: res.data.data,
            })
        }else{
            dispatch({
                type: GET_COMPANY,
                payload: [],
            })
        }
    })
}

export const getLocation = (filter) => (dispatch) => {
    const search_url = "/api/common/location"
    axios.post(search_url,filter).then((res) => {
        if(res.data.result_status === 200){
            dispatch({
                type: GET_LOCATION,
                payload: res.data.data,
            })
        }else{
            dispatch({
                type: GET_LOCATION,
                payload: [],
            })
        }
    })
}

export const getForeman = (filter) => (dispatch) => {
    const search_url = "/api/common/foreman"
    axios.post(search_url,filter).then((res) => {
        if(res.data.result_status === 200){
            dispatch({
                type: GET_FOREMAN,
                payload: res.data.data,
            })
        }else{
            dispatch({
                type: GET_FOREMAN,
                payload: [],
            })
        }
    })
}

export const getJob = (filter) => (dispatch) => {
    const search_url = "/api/common/workjob"
    axios.post(search_url,filter).then((res) => {
        if(res.data.result_status === 200){
            dispatch({
                type: GET_WORKJOB,
                payload: res.data.data,
            })
        }else{
            dispatch({
                type: GET_WORKJOB,
                payload: [],
            })
        }
    })
}

export const getShift = () => (dispatch) => {
    const search_url = "/api/shift"
    axios.get(search_url).then((res) => {
        if(res.data.result_status === 200){
            dispatch({
                type: GET_SHIFT,
                payload: res.data.data,
            })
        }else{
            dispatch({
                type: GET_SHIFT,
                payload: [],
            })
        }
    })
}



